type FieldErrorProps = {
  message?: string;
};

/** Marcação de erro do formik compartilhada por todos os campos do slice. */
function FieldError({ message }: FieldErrorProps) {
  if (!message) return null;
  return (
    <div className="fv-plugins-message-container">
      <div className="fv-help-block">{message}</div>
    </div>
  );
}

export default FieldError;
